import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type {
    PaymentProvider} from "@@/shared/payments/payment-providers";
import {
    paymentProviderZodSchema,
} from "@@/shared/payments/payment-providers";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { UUID } from "@@/shared/uuid";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";
import { orderStatusType } from "./order-status-types";

const orderStatusPaymentRefundInitiatedZodSchema =
    _orderStatusBaseZodSchema.merge(
        z.object({
            type: z.literal(orderStatusType.PAYMENT_REFUND_INITIATED),
            createdBy: userIdZodSchema.or(z.string()),
            paymentUUID: z.string() as unknown as z.ZodType<UUID>,
            refundUUID: z.string() as unknown as z.ZodType<UUID>,
            paymentProvider: paymentProviderZodSchema,
            requestedRefund: priceZodSchema.or(z.literal("ORDER")),
            refundFee: z.boolean(),
            reason: translatableZodSchema,
        }),
    );
type OrderPaymentRefundInitiated = z.infer<
    typeof orderStatusPaymentRefundInitiatedZodSchema
>;

const orderStatusPaymentRefundInitiatedFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly createdBy: UserId | string;
    readonly requestedRefundAmount: Price | "ORDER";
    readonly paymentUUID: UUID;
    readonly refundUUID: UUID;
    readonly paymentProvider: PaymentProvider;
    readonly refundFee: boolean;
    readonly reason: Translatable;
}): OrderPaymentRefundInitiated => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "PAYMENT_REFUND_INITIATED",
    createdBy: params.createdBy,
    paymentUUID: params.paymentUUID,
    paymentProvider: params.paymentProvider,
    requestedRefund: params.requestedRefundAmount,
    refundUUID: params.refundUUID,
    reason: params.reason,
    refundFee: params.refundFee,
});

export {
    orderStatusPaymentRefundInitiatedFactory,
    orderStatusPaymentRefundInitiatedZodSchema,
};
export type { OrderPaymentRefundInitiated };
